import React from "react";
import { App as AntdApp } from "antd";
import AppProviders from "./app/providers/AppProviders";
import AppRouter from "./app/routing/AppRouter";

const App = () => {
    return (
        <AntdApp>
            <AppProviders>
                <AppRouter />
            </AppProviders>
        </AntdApp>
    );
};

export default App;
